import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { VariantFragment } from '@graphql/generated/graphql';
import StrapiImage from '@lib/image/strapiImage';
import { getStrapiAssetUrl } from '@lib/strapi';

interface Props {
    variant: VariantFragment;
}

const imageStyle = ({ theme }: { theme: Theme }) => css`
    display: flex;
    width: 3rem;
    height: 3rem;
    object-fit: cover;
    border-radius: ${theme.shape.radius.sm};
`;

const StyledStrapiImage = styled(StrapiImage)`
    ${imageStyle}
`;

const StyledImage = styled.img`
    ${imageStyle}
`;

const Box = styled.div`
    margin-left: auto;
`;

export const AddToCartSuccessImage = ({ variant }: Props) => {
    return (
        <Box>
            {variant.ImageUrl ? (
                <StyledImage src={variant.ImageUrl} alt={variant.Name} />
            ) : variant.Images?.[0] ? (
                <StyledStrapiImage
                    sizes='3rem'
                    src={getStrapiAssetUrl(variant.Images[0])}
                    formats={variant.Images[0].formats}
                    alt={variant.Images[0].alternativeText ?? variant.Name}
                />
            ) : null}
        </Box>
    );
};
